import { render, staticRenderFns } from "./productAssociationDialog.vue?vue&type=template&id=6a6dc6fd&scoped=true&"
import script from "./productAssociationDialog.vue?vue&type=script&lang=tsx&"
export * from "./productAssociationDialog.vue?vue&type=script&lang=tsx&"
import style0 from "./productAssociationDialog.vue?vue&type=style&index=0&id=6a6dc6fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6dc6fd",
  null
  
)

export default component.exports